module.exports = __webpack_public_path__ + "static/media/eventpageClassImage.432f1ad7.svg";